import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import 'swiper/swiper.scss';
import LayoutListHorizontal from './LayoutListHorizontal';

const useStylesSectionItemList = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(1),
  },
  head: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    // borderBottom: '2px solid #D0D0D0',
  },
  mark: {
    position: 'absolute',
    bottom: -3,
    width: 100,
    borderBottom: `4px solid ${theme.palette.primary.main}`,
  },
  title: {
    fontSize: 24,
    fontWeight: '900',
  },
}));

SectionItemList.propTypes = {
  title: PropTypes.string,
  buttonRightText: PropTypes.string,
  buttonRightOnClick: PropTypes.func,
  small: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  itemRender: PropTypes.elementType.isRequired,
  layout: PropTypes.elementType,
};

export default function SectionItemList({
  title,
  buttonRightText,
  buttonRightOnClick,
  small,
  data,
  itemRender,
  layout = LayoutListHorizontal,
}) {
  const classes = useStylesSectionItemList({small});

  if (!data.length) {
    return null;
  }

  return (
    <section className={classes.root}>
      <div className={classes.head}>
        <div>
          {/* mark */}
          {/* <div className={classes.mark} /> */}
          {/* title */}
          <Typography className={classes.title}>{title}</Typography>
        </div>
        {/* button right */}
        <div>
          {buttonRightText && (
            <Button color='secondary' href={buttonRightOnClick}>{buttonRightText}</Button>
          )}
        </div>
      </div>
      {React.createElement(layout, {small, data, itemRender})}
    </section>
  );
}
